import React, { useEffect, useRef, useState } from "react";
import "./VideoField.scss";
import urls from "config/urls";
import AxiosInterceptor from "../../../AxiosInterceptor";
import { IconButton } from "@mui/material";
import { Spinner } from "components/Spinner/Spinner";
import { FieldEditControls } from "components/FieldEditControls/FieldEditControls";
import Icon from "components/Icon/Icon";

const VideoField = (props: any) => {
  let {
    defaultValue,
    editable,
    label,
    editPath,
    id,
    onChange,
    accept = "video/*",
    //readonly,
    folder = "videos",
    mode,
  }: any = props;
  const [value, setValue] = useState(defaultValue as any);
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [processing, setProcessing] = useState(false);
  const fileInputRef = useRef(null);
  const removeVideo = () => {
    setValue(null);
  };
  useEffect(() => {
    if (onChange) {
      console.log("value", value);
      onChange(value);
    }
  }, [value]);
  useEffect(() => {
    console.log(defaultValue);
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = async (e: any) => {
    if (e.target.files) {
      let reader = new FileReader();
      const file: File = e.target.files[0];
      const extension = file.name.split(".").pop();
      reader.readAsDataURL(file);
      reader.onload = await function () {
        console.log(reader.result);
        const data = {
          content: reader.result,
          extension,
          folder: folder,
        };
        saveVideo(data);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
      // Resetear el valor del input de archivo
      e.target.value = null;
    } else {
      console.log("No Video selected");
    }
  };

  const saveVideo = async ({ content, extension, folder }: any) => {
    setProcessing(true);
    try {
      const res = await AxiosInterceptor.post(`${urls.server}/api/videos`, {
        file_content: content,
        extension,
        folder,
      });
      const resData = await res?.data;
      setValue(resData?.path);
      setProcessing(false);
    } catch (error: any) {
      setProcessing(false);
    }
  };
  return (
    <div className="video-field-container">
      {label && (
        <label>
          <span>{label}</span>
        </label>
      )}
      <div className="content">
        {mode == 'readonly' ||
          (mode == 'edit' && editable && !isEditEnabled) ||
          (mode == 'edit' && !editable) ? (
          <div className="readonly-content">
            {value ? (
              <div className="video-preview-wrapper">
                <video src={`${urls.server}${value}`} autoPlay controls>
                  El navegador no admite el elemento <code>video</code>.
                </video>
              </div>
            ) : (
              <div className="no-value">
                <Icon name="video" />
                <span>Sin Video</span>
              </div>
            )}
          </div>
        ) : (
          <div className="editable-content">
            {processing ? (
              <div className="spinner-wrapper">
                <Spinner size="sm" />
              </div>
            ) : (
              <>
                {!value && (
                  <div className="add-image-btn">
                    <input
                      id={id}
                      accept={accept}
                      type="file"
                      onChange={handleChange}
                      ref={fileInputRef}
                    />
                    <div>
                      <div>
                        <Icon name="video" />
                        <span>Seleccionar Video</span>
                      </div>
                      <label htmlFor={id}></label>
                    </div>
                  </div>
                )}
                {value && (
                  <div className="video-preview-wrapper">
                    <video src={`${urls.server}${value}`} autoPlay controls>
                      El navegador no admite el elemento <code>video</code>.
                    </video>

                    <IconButton aria-label="delete" onClick={removeVideo}>
                      <Icon name="delete" />
                    </IconButton>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
      {editable && (
        <div className="btns">
          {(mode == 'edit' && editable) && (

            <FieldEditControls
              value={value}
              fieldName={label}
              editPath={editPath}
              onEditStart={() => {
                setIsEditEnabled(true);
              }}
              onEditCancel={(originalValue) => {
                setIsEditEnabled(false);
                setValue(originalValue);
              }}
              onEditEnd={(success: boolean, originalValue) => {
                setIsEditEnabled(false);
                if (!success) {
                  setValue(originalValue);
                }
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export { VideoField };
